<template>
  <h1>Welcome!</h1>
  <div class="textbody">
  <p>Welcome to my currently quite minimal website. This website was created for the purposes of the capstone course PHY 481, but will eventually be shaped and made into a more complete and personal website.</p>
  <p>There are many directions that this initial version of my personal website could have taken, but I have chosen to prioritize making a fully custom website and getting that up and running. The website front-end and router is done with Vue and is a single-page application. The image is hosted on fly.io, and the domain name was registered through CloudFlare.</p>
  <p>If you are looking for the PHY 481 Capstone Project info page, <router-link :to="{ name: 'Capstone' }">it is here</router-link>.</p>
  </div>
</template>


<script>

</script>


<style scoped>
div {
  width: 60%;
  display: inline-block;
  text-align: center;
  border-width: 8px;
  border-radius: 30px;
  border-color: rgba(0,128,128,0.3);
  border-left-style: solid;
  border-right-style: solid;
  padding: 0em 2em 0em 2em;
  margin-bottom: 4em;
}
div p {
  text-indent: 2em;
  text-align: left;
  font-size: 1.5em;
  margin: 2em 0em;
  margin-left: -0.5em;
  padding-left: 0.5em;
}
</style>